import React from "react";
import { LogOut } from "lucide-react";
import SidebarUpgradePanel from "../../uiComponents/SidebarUpgradePanel";
import type { DashboardSidebarProps } from "../../../types/billing";

const brandLogo = `${process.env.PUBLIC_URL}/impret-icon.svg`;

const DashboardSidebar: React.FC<DashboardSidebarProps> = ({
  userName,
  userEmail,
  planName,
  betaEnabled = false,
  betaLabel,
  showUpgradeCard = true,
  usageMetrics,
  navItems,
  onNavClick,
  onAddBrand,
  onUpgrade,
  onLogout,
  isUpgradeDisabled = false,
  isUpgradeLoading = false,
}) => {
  return (
    <aside className="dashboard-sidebar">
      <div className="dashboard-sidebar__brand">
        <div className="dashboard-sidebar__brand-icon">
          <img
            src={brandLogo}
            alt=""
            className="dashboard-sidebar__brand-logo"
          />
        </div>
        <div>
          <div className="dashboard-sidebar__eyebrow">Workspace</div>
          <div className="dashboard-sidebar__brand-name">Impret</div>
        </div>
      </div>

      <section className="dashboard-sidebar__plan-card">
        <div className="dashboard-sidebar__plan-row">
          <span className="dashboard-sidebar__plan-label">Current plan</span>
          <span className="dashboard-sidebar__plan-pill">{planName}</span>
        </div>

        <div className="dashboard-sidebar__usage-list">
          {usageMetrics.map((metric) => (
            <div key={metric.id} className="dashboard-sidebar__usage-item">
              <div className="dashboard-sidebar__usage-meta">
                <span>{metric.label}</span>
                <strong>
                  {metric.used}/{metric.limitLabel}
                </strong>
              </div>
              <div className="dashboard-sidebar__progress-track">
                <span
                  className="dashboard-sidebar__progress-fill"
                  style={{ width: `${metric.progress}%` }}
                />
              </div>
              <p className="dashboard-sidebar__usage-helper">{metric.helper}</p>
            </div>
          ))}
        </div>
      </section>

      {/* <nav className="dashboard-sidebar__nav" aria-label="Dashboard sections">
        {navItems.map((item) => (
          <button
            key={item.id}
            type="button"
            className="dashboard-sidebar__nav-item"
            onClick={() => onNavClick(item.sectionId)}
          >
            <span className="dashboard-sidebar__nav-icon">
              {renderNavIcon(item.icon)}
            </span>
            <span>{item.label}</span>
          </button>
        ))}
      </nav> */}
      {/* 
      <button
        type="button"
        className="dashboard-sidebar__quick-action"
        onClick={onAddBrand}
      >
        <Plus size={16} />
        Add brand
      </button> */}

      <SidebarUpgradePanel
        userName={userName}
        userEmail={userEmail}
        onUpgrade={onUpgrade}
        mode={betaEnabled ? "beta" : "upgrade"}
        betaLabel={betaLabel}
        disabled={isUpgradeDisabled}
        loading={isUpgradeLoading}
        showUpgradeCard={showUpgradeCard}
      />

      <div className="dashboard-sidebar__footer">
        <button
          type="button"
          className="dashboard-sidebar__logout"
          onClick={() => {
            void onLogout();
          }}
        >
          <LogOut size={15} />
          Logout
        </button>
      </div>
    </aside>
  );
};

export default DashboardSidebar;
